const light = Object.freeze({
    primary: '#031D38',
    secondary: '#61A706',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#61A706',
    secondary: '#1E40AF',
    navBackground: '#1B314D',
    tileBackground: '#1B314D',
    appBackground: '#031D38',
    inputBackground: '#0B2545',
    logoColor: '#FFFFFF',
    logoFontColor: '#FFFFFF',
    error: '#F99C9D',
    info: '#90C9F9',
    success: '#A5D6A7',
    warning: '#FFCB7F',
})

const props = Object.freeze({
    headerLogoWidth: 150,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg'),
    timelineHeaderImage: 'living-header.jpg'
})

module.exports = Object.freeze({
    light,
    dark,
    props
})
